// Services data constants
export const SERVICES_LIST = [
  'Roofing',
  'Windows',
  'Siding',
  'Gutters',
  'Repairs'
];

export const FINANCING_FEATURES = [
  {
    icon: 'FaCreditCard',
    title: '100% Financing',
    description: 'Qualified applicants can finance up to 100% of their project'
  },
  {
    icon: 'FaDollarSign',
    title: 'Competitive Rates',
    description: 'Low interest rates and flexible terms available'
  },
  {
    icon: 'FaCheckCircle',
    title: 'Quick Approval',
    description: 'Fast and easy application process with same-day decisions'
  }
];
